import type { Pitch } from './pitch';

/** The twelve common tonic spellings used by the interactive theory labs. */
export const COMMON_TONICS: { label: string; pitch: Pitch }[] = [
  { label: 'C', pitch: { letter: 'C', alter: 0, octave: 4 } },
  { label: 'D♭', pitch: { letter: 'D', alter: -1, octave: 4 } },
  { label: 'D', pitch: { letter: 'D', alter: 0, octave: 4 } },
  { label: 'E♭', pitch: { letter: 'E', alter: -1, octave: 4 } },
  { label: 'E', pitch: { letter: 'E', alter: 0, octave: 4 } },
  { label: 'F', pitch: { letter: 'F', alter: 0, octave: 4 } },
  { label: 'F♯', pitch: { letter: 'F', alter: 1, octave: 4 } },
  { label: 'G', pitch: { letter: 'G', alter: 0, octave: 4 } },
  { label: 'A♭', pitch: { letter: 'A', alter: -1, octave: 4 } },
  { label: 'A', pitch: { letter: 'A', alter: 0, octave: 4 } },
  { label: 'B♭', pitch: { letter: 'B', alter: -1, octave: 4 } },
  { label: 'B', pitch: { letter: 'B', alter: 0, octave: 4 } },
];
